// Hands a Blob to the browser as a file download.
//
// The object URL is revoked on a timer rather than right after the click: revoking it
// synchronously can cut off a download the browser has not finished reading yet, which
// bites on anything larger than a few KB.
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export function saveText(content, filename) {
  saveBlob(new Blob([content], { type: 'text/plain' }), filename);
}
